import "../../tools/corporateTube/_languageData";
import "../../tools/corporateTube/guessLanguage";
import * as Embed from "../../tools/corporateTube/embed";
import "../../tools/corporateTube/iframeResizer.min";

export default class BfvIframeSizeHandler {
  constructor(options = {}) {
    this.$root = options.element;
    this.$iframe = this.$root.querySelector("#ct-frame-wrapper iframe");
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    // document.addEventListener('DOMContentLoaded', () => {
    const WRAPPER = "ct-frame-wrapper";
    // const baseUrl = 'http://localhost:3000/infothekDemoPages/infothekBfvTvCorporateTube.html';
    const baseUrl = window.location;
    const ctUrl = "https://bfv.corporate.tube";
    const ctEmbedded = new Embed.CtEmbedded(
      {
        baseUrl,
        wrapperId: WRAPPER,
      },
      ctUrl,
    );

    ctEmbedded.subscribe((exchangeMessage) => {
      // resize current iframe to follow inner height of the corporte tube
      const iframe = this.$iframe;

      iframe.style.height = `${exchangeMessage.windowHeight} px`;

      // This line add changed ct iframe route to parent website integration page
      // In the other words end user will be able to copy url and send to someone in order to share ct deep linkable content
      if (exchangeMessage.routeChanged) {
        window.history.replaceState(
          window.history.state,
          "iframe",
          baseUrl + exchangeMessage.routeChanged,
        );
      }
    });
    window.iFrameResize({ checkOrigin: false });
    // });
  }
}

